module.exports = __webpack_public_path__ + "img/4-1.f7b1b1da.jpg";